import {defineMessage} from "react-intl"
export const mfaToastMessages = {
    "smsVerificationCodeSent": defineMessage({id: "smsVerificationCodeSent", defaultMessage: "Verification code sent via SMS!", description: "A 'toast' message that pops up after an sms is sent."}),
    "emailVerificationCodeSent": defineMessage({id: "emailVerificationCodeSent", defaultMessage: "Verification code sent to your email!", description: "A 'toast' message that pops up after an email is sent."})
}
